module.exports = __webpack_public_path__ + "img/img20.0ab49003.svg";